import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTable,
  faCalculator,
  faSquareRootAlt,
  faChartLine,
  faArrowTrendUp,
  faRetweet,
  faBarsProgress,
  faSubscript,
  faTableColumns,
  faChartPie,
  faDice,
  faExchangeAlt,
  faRulerCombined,
  faSuperscript,
  faBars, // Hamburger icon
} from "@fortawesome/free-solid-svg-icons";

import AntilogarithmTable from "./AntilogarithmTable";
import BinomialCoefficientCalculator from "./BinomialCoefficientCalculator";
import ComprehensiveMathTable from "./ComprehensiveMathTable";
import ControlChartsConstant from "./ControlChartsConstant";
import ExponentialTable from "./ExponentialTable";
import FisherZTransformation from "./FisherZTransformation";
import FTableGenerator from "./FTableGenerator";
import LogrithmTable from "./LogrithmTable";
import MathFuctions from "./MathFuctions";
// import NormalAreaTable from "./NormalAreaTable";
import PoissonCumulativeTable from "./PoissonCumulativeTable";
import RandomNumberTable from "./RandomNumberTable";
import ReciprocalTable from "./ReciprocalTable";
import SquareRootTable from "./SquareRootTable";
import SquareRootTableRange from "./SquareRootTableRange";
import SquareTable from "./SquareTable";
import TTableGenerator from "./TTableGenerator";

import "./LASTHome.css";

// Component mapping for dynamic rendering
const componentMapping = {
  AntilogarithmTable: <AntilogarithmTable />,
  BinomialCoefficientCalculator: <BinomialCoefficientCalculator />,
  ComprehensiveMathTable: <ComprehensiveMathTable />,
  ControlChartsConstant: <ControlChartsConstant />,
  ExponentialTable: <ExponentialTable />,
  FisherZTransformation: <FisherZTransformation />,
  FTableGenerator: <FTableGenerator />,
  LogrithmTable: <LogrithmTable />,
  MathFuctions: <MathFuctions />,
//   NormalAreaTable: <NormalAreaTable />,
  PoissonCumulativeTable: <PoissonCumulativeTable />,
  RandomNumberTable: <RandomNumberTable />,
  ReciprocalTable: <ReciprocalTable />,
  SquareRootTable: <SquareRootTable />,
  SquareRootTableRange: <SquareRootTableRange />,
  SquareTable: <SquareTable />,
  TTableGenerator: <TTableGenerator />,
};

const categories = [
  { to: "AntilogarithmTable", icon: faTable, label: "Antilogarithm Table", bgColor: "bg-gray-600" },
  { to: "BinomialCoefficientCalculator", icon: faCalculator, label: "Binomial Coefficient Calculator", bgColor: "bg-blue-600" },
  { to: "ComprehensiveMathTable", icon: faSquareRootAlt, label: "Comprehensive Math Table", bgColor: "bg-green-600" },
  { to: "ControlChartsConstant", icon: faChartLine, label: "Control Charts Constant", bgColor: "bg-teal-500" },
  { to: "ExponentialTable", icon: faArrowTrendUp, label: "Exponential Table", bgColor: "bg-orange-600" },
  { to: "FisherZTransformation", icon: faRetweet, label: "Fisher Z Transformation", bgColor: "bg-purple-500" },
  { to: "FTableGenerator", icon: faTable, label: "F Table Generator", bgColor: "bg-indigo-700" },
  { to: "LogrithmTable", icon: faBarsProgress, label: "Logarithm Table", bgColor: "bg-yellow-600" },
  { to: "MathFuctions", icon: faSubscript, label: "Math Functions", bgColor: "bg-pink-600" },
//   { to: "NormalAreaTable", icon: faTableColumns, label: "Normal Area Table", bgColor: "bg-red-500" },
  { to: "PoissonCumulativeTable", icon: faChartPie, label: "Poisson Cumulative Table", bgColor: "bg-cyan-500" },
  { to: "RandomNumberTable", icon: faDice, label: "Random Number Table", bgColor: "bg-gray-500" },
  { to: "ReciprocalTable", icon: faExchangeAlt, label: "Reciprocal Table", bgColor: "bg-green-700" },
  { to: "SquareRootTable", icon: faSquareRootAlt, label: "Square Root Table", bgColor: "bg-blue-700" },
  { to: "SquareRootTableRange", icon: faRulerCombined, label: "Square Root Table (Range)", bgColor: "bg-indigo-500" },
  { to: "SquareTable", icon: faSuperscript, label: "Square Table", bgColor: "bg-orange-700" },
  { to: "TTableGenerator", icon: faTable, label: "T Table Generator", bgColor: "bg-purple-600" },
];

const LASTHome = () => {
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false); // State to toggle mobile menu visibility

  return (
    <MainLayout>
      <div className="mt-12 flex flex-col sm:flex-row">
        {/* Hamburger Menu Icon (visible on mobile only) */}
        <div className="sm:hidden p-4">
          <button
            onClick={() => setMenuVisible(!menuVisible)}
            className="text-white bg-blue-600 p-2 rounded"
          >
            <FontAwesomeIcon icon={faBars} size="lg" />
          </button>
        </div>

        {/* Side Menu */}
        <div className={`w-full sm:w-1/4 p-4 bg-gray-100 rounded ${menuVisible ? "block" : "hidden sm:block"}`}>
          <div className="grid grid-cols-1 gap-4">
            {categories.map((category, index) => (
              <div
                key={index}
                className={`p-4 ${category.bgColor} text-white rounded shadow cursor-pointer hover:scale-105 transition`}
                onClick={() => {
                  setSelectedComponent(category.to);
                  setMenuVisible(false); // Close menu after selection on mobile
                }}
              >
                <FontAwesomeIcon icon={category.icon} size="m" /><span className="ml-2 text-s">{category.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Component Display */}
        <div className="w-full sm:w-3/4 p-4 bg-gray-600 rounded shadow ml-0 sm:ml-4 mt-4 sm:mt-0">
          {selectedComponent ? (
            componentMapping[selectedComponent]
          ) : (
            <div className="text-lg text-yellow-200">Please select an item from the menu</div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default LASTHome;
